import { DigitalFormsTypes } from '@frontend/api-digital-forms';
import { Status } from '@frontend/design-system';
import { DigitizationTypes } from '../../../../../../../../types';
import { getCurrentStep } from '../../../../../../../../utils';

const STEPS_ORDER = [
  DigitizationTypes.DigitizationStep.UPLOAD_FORMS,
  DigitizationTypes.DigitizationStep.IN_PROGRESS,
  DigitizationTypes.DigitizationStep.COMPLETED,
];

type GetStepStatusFn = (step: DigitizationTypes.DigitizationStep) => Status;

interface CreateStepStatusEvaluatorResults {
  getStepStatus: GetStepStatusFn;
}

export function createStepStatusEvaluator(
  latestProcessStageDates: DigitalFormsTypes.Schema.DigitiseFormsDetails_StageDates
): CreateStepStatusEvaluatorResults {
  const currentStepStatus = getCurrentStep(latestProcessStageDates);
  const currentStepIndex = STEPS_ORDER.indexOf(currentStepStatus);

  const getStepStatus: GetStepStatusFn = (step) => {
    const stepIndex = STEPS_ORDER.indexOf(step);

    if (stepIndex < currentStepIndex) {
      return 'completed';
    } else if (stepIndex === currentStepIndex) {
      return 'active';
    } else {
      return 'inactive';
    }
  };

  return {
    getStepStatus,
  };
}
